import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getArticleById, updatePreviewArticle } from './_request';
import { useAuth } from '../context/AuthContext';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const ReviewArticle = () => {
  const navigate = useNavigate();
  const { authToken } = useAuth();
  const location = useLocation();
  const { articleId } = location.state;
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [readTime, setReadTime] = useState('');
  const [category, setCategory] = useState('');
  const [parentCategory, setParentCategory] = useState('');
  const [articleType, setArticleType] = useState('');
  const [year, setYear] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const article = await getArticleById(authToken, articleId);
        if (article.Result) {
          const data = article.Article;
          setTitle(data.title);
          setContent(data.content);
          setReadTime(data.read_min);
          setParentCategory(data.parentCategory || '');
          setCategory(data.category);
          setArticleType(data.article_type);
          setYear(data.year);
        }
      } catch (err) {
        setError('Failed to fetch article data');
      }
    };
    fetchArticle();
  }, [articleId, authToken]);


  const activeArticle = async () => {
    setLoading(true);
    try {
      const response = await updatePreviewArticle(authToken, articleId);
      if (response.Result) {
        alert('Article Posted')
        navigate('/tazakraatreview')
      }
    } catch (error) {
      setError('Failed to post article');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-5xl mx-auto p-6 bg-white shadow-md rounded-lg">
      {error && <p className="text-red-500">{error}</p>}
      <h1 className="text-2xl font-bold mb-4">Review Your Article</h1>

      <p className="text-gray-600 mb-2">{`Category: ${parentCategory} > ${category}`}</p>
      <p className="text-gray-600 mb-2">{`Article Type: ${articleType}`}</p>
      <div dir="rtl" className='flex flex-col gap-9 border-b-[1px] mb-4 p-2'>
        {/* Article Image and Title */}
        <div
          className="bg-primaryBG w-full h-[100px] lg:h-[200px] flex flex-col items-center justify-center relative rounded-3xl"
        >
          <div className='flex flex-col justify-center align-middle items-center gap-[10px] lg:gap-[20px] w-full bg-blend-color-blur p-4 inset-0 backdrop-blur-lg'>
            <p style={{ color: '#222', fontWeight: 700, fontSize: '2rem' }} className='font-nastaleeqRegular'>{title}</p>
            <ul className='text-black list-disc flex gap-4 lg:gap-10 pr-4'>
              {readTime && (
                <li className='font-nastaleeqRegular'>{readTime} منٹ پڑھنے کا وقت</li>
              )}
              <li>
                <p dir='ltr'>{year}</p>
              </li>
            </ul>
          </div>
        
        </div>
        {/* Article Content */}
        <div>
          <div className="w-full text-right text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular group" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
      <div className="flex justify-end space-x-4">
      <Button
          variant="contained"
          color="primary"
          onClick={()=>navigate('/tazakraatreview')}
        >
            Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/tazakraatreview/editArticle', { state: { articleId } })}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Edit'}
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={activeArticle}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Post'}
        </Button>
      </div>
    </div>
  );
};

export default ReviewArticle;
